const AUTH_TOKEN_HEADER = 'auth-token'
const USER_NAME_KEY = 'userName'

export function getToken () {
  return localStorage.getItem(AUTH_TOKEN_HEADER)
}

export function saveToken (token) {
  localStorage.setItem(AUTH_TOKEN_HEADER, token)
}

export function removeToken () {
  localStorage.removeItem(AUTH_TOKEN_HEADER)
}

export function saveUserName (userName) {
  localStorage.setItem(USER_NAME_KEY, userName)
}

export function getUserName () {
  return localStorage.getItem(USER_NAME_KEY)
}
